import { render, staticRenderFns } from "./SystemAlertSetting.vue?vue&type=template&id=5f391cde&scoped=true"
import script from "./SystemAlertSetting.vue?vue&type=script&lang=js"
export * from "./SystemAlertSetting.vue?vue&type=script&lang=js"
import style0 from "./SystemAlertSetting.vue?vue&type=style&index=0&id=5f391cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f391cde",
  null
  
)

export default component.exports